'use client'

import { useEffect } from 'react'

export function useAffiliateTracking() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    let tracking: string | null = null

    const params = new URLSearchParams(window.location.search)
    tracking = params.get('tracking')

    if (!tracking) {
      const match = window.location.href.match(/[?&]tracking=([^&]+)/)
      if (match) tracking = decodeURIComponent(match[1])
    }

    if (!tracking) return

    if (document.cookie.includes('tracking=')) return

    fetch(`/api/tracking?tracking=${encodeURIComponent(tracking)}`, {
      credentials: 'include',
    }).catch(() => {})
  }, [])
}